<template>
  <div class="apexchartvue" @pointerdown.stop id="chart">
    <apexchart type="candlestick" width="1500px" :options="chartOptions" :series="value" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: ["emitter", "ikey", "getData", "putData"],
  data() {
    return {
      value: [
        {
          data: [
            {
              x: new Date(),
              y: [100, 105, 99, 1914]
            }
          ]
        }
      ],
      annotationHashs: new Set([]),
      annotationYHashs: {},
      annotations: {
        xaxis: [
          {
            // in a datetime series, the x value should be a timestamp, just like it is generated below
            x: new Date("12/17/2018").getTime(),
            x2: new Date("12/30/2018").getTime(),

            strokeDashArray: 0,
            borderColor: "#775DD0",
            label: {
              borderColor: "#775DD0",
              style: {
                color: "#fff",
                background: "#775DD0"
              },
              text: "X Axis Anno Vertical"
            }
          }
        ]
      },
      chartOptions: {
        annotations: {},
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              customIcons: []
            },
            autoSelected: "zoom"
          },
          animations: {
            enabled: false
          },
          zoom: {
            autoScaleYaxis: true
          },
          background: "#fff"
        },
        title: {
          text: "CandleStick Chart",
          align: "left"
        },
        xaxis: {
          type: "datetime"
        },
        yaxis: {
          tooltip: {
            enabled: true
          }
        }
      }
    };
  },
  methods: {
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 10)];
      }
      return color;
    },
    createYAnnotation(key, numberIn) {
      if (this.annotationYHashs[key] === undefined) {
        var color = this.getRandomColor();
        this.annotationYHashs[key] = {
          y: numberIn,
          borderColor: color,
          strokeDashArray: 10,

          //figure out how to get style working for line
          style: {
            strokewidth: 5
          },
          label: {
            borderColor: "0",
            style: {
              opacity: "0",
              color: color,
              borderColor: "0",
              background: "transparent"
            },
            text: key
          }
        };
      } else {
        this.annotationYHashs[key].y = numberIn;
      }
    },
    createAnnotation(stocks) {
      var start = stocks[0].data[0].x;
      var len = stocks[0].data.length - 1;
      var end = stocks[0].data[len].x;
      var key = `${start}++${end}`;
      this.annotationHashs.add(key);
      return {
        // in a datetime series, the x value should be a timestamp, just like it is generated below
        x: start,
        x2: end,

        strokeDashArray: 0,
        borderColor: "#775DD0",
        label: {
          borderColor: "#775DD0",
          style: {
            color: "#fff",
            background: "#775DD0"
          },
          text: "xS"
        }
      };
    },
    hasYAnnotation(key, numberIn) {
      return this.annotationYHashs[key] == numberIn;
    },
    hasAnnotation(stocks) {
      var start = stocks[0].data[0].x;
      var len = stocks[0].data.length - 1;
      var end = stocks[0].data[len].x;
      var key = `${start}++${end}`;
      return this.annotationHashs.has(key);
    },
    addYAnnotation(key, numberIn) {
      this.createYAnnotation(key, numberIn);

      this.annotations.yaxis = Object.values(this.annotationYHashs);
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          annotations: this.annotations
        }
      };
    },
    addAnnotation(stocks) {
      this.annotations.xaxis.push(this.createAnnotation(stocks));
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          annotations: this.annotations
        }
      };
    },
    clearAnnotation() {
      this.annotationHashs.clear();
      this.annotationYHashs = {};
      this.annotations.xaxis = [];
      this.annotations.yaxis = [];
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          annotations: this.annotations
        }
      };
    }
  },
  mounted() {
    this.chartOptions = {
      ...this.chartOptions,
      ...{
        annotations: this.annotations
      }
    };
  },
  components: {
    apexchart: VueApexCharts
  }
};
</script>

<style>
.apexchartvue .apexcharts-yaxis-annotations rect {
  opacity: 0;
}
.apexchartvue .apexcharts-yaxis-annotations line {
  stroke-width: 2.5;
}
</style>